import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Container, FormGroup, Input, Label, Row } from "reactstrap"

// Import Editor
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

//Import Date Picker
import "react-datepicker/dist/react-datepicker.css"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { convertFromRaw, convertToRaw, EditorState } from "draft-js"
import { connect } from "react-redux"
import {
  buscarSugestao,
  buscarSugestoesProdutos,
  buscarSugestoesStatus,
  doEditSuggestion,
  sugestao
} from "../../store/auth/profile/actions"
import { isArray } from "leaflet/src/core/Util"
import Loader from "react-loader-spinner"
import Select from "react-select"
import usePermission from "helpers/permission/usePermission"
import StickerToolbarButtons from "../../components/Common/sticker-toolbar-buttons";
import { useLocation } from "react-router-dom"
import { navegarBreadCrumb } from "../../store/navigator/actions"
import ButtonRedirect from "../../components/Common/button-redirect"

const CadastrarSugestao = props => {

  const [paramIdCloud, setParamIdCloud] = useState(undefined)
  const [sugestoesStatusArr, setSugestoesStatusArr] = useState([])
  const [sugestoesProdutosArr, setSugestoesProdutosArr] = useState([])

  const [sugestao, setSugestao] = useState("")
  const [produto, setProduto] = useState("")
  const [anexo, setAnexo] = useState("")
  const [statusId, setStatusId] = useState(0)
  const [editorState, setEditorState] = useState(EditorState.createEmpty())

  const usePermissionEdit = usePermission('sugestoesEdit_editar')
  const usePermissionInsert = usePermission('sugestoesEdit_inserir')
  const location = useLocation();

  useEffect(() => {
    props.buscarSugestoesProdutos()
    props.buscarSugestoesStatus()
  }, [])


  const getAndSearch = (idCloud)=>{
    props.buscarSugestao({id: idCloud}, props.history)
    props.navegarBreadCrumb( {title: `breadcrumb.suggestion`, link: location.pathname, id: idCloud})
  }


  useEffect(() => {
    if(paramIdCloud !== undefined) return

    const idCloud = props.match.params.hasOwnProperty('idCloud') ? props.match.params.idCloud : null
    if (idCloud) {
      getAndSearch(idCloud)
    } else {
      setSugestao("")
      setProduto("")
      setAnexo("")
      props.navegarBreadCrumb({title: `breadcrumb.suggestion.new`, link: location.pathname} )
    }

    setParamIdCloud(idCloud)
  }, [props.match.params])



  useEffect(() => {
    if (props.editingSuggestion) {
      setSugestao(props.editingSuggestion.conteudo)
      setProduto(props.editingSuggestion.produto)
      setAnexo(props.editingSuggestion.anexo)
      setStatusId(props.editingSuggestion.status_id)
      setEditorState(prevState =>
        EditorState.createWithContent(
          convertFromRaw(JSON.parse(props.editingSuggestion?.detalhes))
        )
      )

    } else {
      setSugestao("")
      setProduto("")
      setAnexo("")
      setStatusId(0)
      setEditorState(prevState => EditorState.createEmpty())

    }

    return () => {
      setSugestao("")
      setProduto("")
      setAnexo("")
      setStatusId(0)
      setEditorState(prevState => EditorState.createEmpty())
    }
  }, [props.editingSuggestion])

  useEffect(() => {
    setSugestoesStatusArr(
      props.sugestoesStatus && Array.isArray(props.sugestoesStatus)
        ? props.sugestoesStatus.map(e => ({
          label: e.nome,
          value: e.id.toString()
        }))
        : []
    )
    return () => { setSugestoesStatusArr([])}
  }, [props.sugestoesStatus])

  useEffect(() => {
    setSugestoesProdutosArr(
      props.sugestoesProdutos && Array.isArray(props.sugestoesProdutos)
        ? props.sugestoesProdutos.map(e => ({
          label: e.descricao,
          value: e.descricao
        }))
        : []
    )

    return () => { setSugestoesProdutosArr([])}
  }, [props.sugestoesProdutos])

  const handleFile = files => {
    const reader = new FileReader()
    reader.onload = () => {
      setAnexo({
        name: files[0].name,
        b64: reader.result
      })
    }
    reader.readAsDataURL(files[0])
  }

  const handleValidSubmit = (e, v) => {
    props.sugestao(
      {
        id: props.activeSuggestion ? props.activeSuggestion.id : null,
        sugestao,
        produto,
        anexo,
        statusId,
        detalhes: JSON.stringify(convertToRaw(editorState.getCurrentContent()))
      },
      props.history
    )
  }


  return props.sugestoesStatusLoading ||
  props.sugestoesProdutosLoading ||
  props.sugestaoLoading ? (
    <div className="loader-container">
      <Loader type="ThreeDots" color="#556EE6" height={ 80 } width={ 80 } />
    </div>
  ) : (
    <>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumbs */ }
          <Breadcrumbs
            title={
              (props.suggestionMode === "edit" && "breadcrumb.suggestion.edit") ||
              (props.suggestionMode === "view" && "breadcrumb.suggestion.view") ||
              "breadcrumb.suggestion.new"
            }
          />
          <StickerToolbarButtons>
            <ButtonRedirect path={"sugestoes"} history={props.history}></ButtonRedirect>
            { usePermissionEdit && props.suggestionMode === "edit" &&
                <Button type="submit" color="primary"
                        disabled={ !sugestao || !produto || props.suggestionMode === "view" }
                        onClick={ e => handleValidSubmit() } >
                  Salvar Sugestão
                </Button>
            }
            { usePermissionInsert && props.suggestionMode !== "edit" &&
                <Button type="submit" color="primary"
                        disabled={ !sugestao || !produto || props.suggestionMode === "view" }
                        onClick={ e => handleValidSubmit() } >
                  Cadastrar Sugestão
                </Button>
            }
          </StickerToolbarButtons>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    { (props.suggestionMode === "edit" && "Altere a Sugestão") ||
                    (props.suggestionMode === "view" &&
                      "Visualize sua Sugestão") ||
                    "Envie sua Sugestão" }
                  </CardTitle>
                  <form>
                    <div className="outer">
                      <div className="outer">
                        <FormGroup className="mb-4" row>
                          <Label
                            htmlFor="sugestao"
                            className="col-form-label col-lg-2"
                          >
                            Sugestão
                          </Label>
                          <Col lg="10">
                            <Input
                              id="sugestao"
                              name="sugestao"
                              type="text"
                              className="form-control"
                              placeholder="Digite a Sugestão..."
                              value={ sugestao }
                              onChange={ e => setSugestao(e.target.value) }
                              readOnly={ props.suggestionMode === "view" }
                            />
                          </Col>
                        </FormGroup>

                        { props.suggestionMode === "edit" && (
                          <FormGroup className="mb-4" row>
                            <Label className="col-form-label col-lg-2">
                              Status
                            </Label>
                            <Col lg="10">
                              <select
                                className="form-select select2-search-disable"
                                value={ statusId }
                                onChange={ e => setStatusId(e.target.value) }
                              >
                                { isArray(props.sugestoesStatus) &&
                                props.sugestoesStatus.map((item, key) => (
                                  <option key={ item.value } value={ item.id }>{ item.nome }</option>
                                )) }
                              </select>
                            </Col>
                          </FormGroup>
                        ) }

                        <FormGroup className="mb-4" row>
                          <Label
                            htmlFor="produto"
                            className="col-form-label col-lg-2"
                          >
                            Produto
                          </Label>
                          <Col lg="10">
                            <Select
                              id="produto"
                              name="produto"
                              className="basic-single"
                              options={ sugestoesProdutosArr }
                              placeholder="Digite o Produto..."
                              isClearable={ true }
                              isSearchable={ true }
                              noOptionsMessage={ () =>
                                "Nenhum produto encontrado"
                              }
                              onChange={ e => setProduto(e?.value) }
                              value={
                                produto
                                  ? sugestoesProdutosArr.find(
                                    u => u.value === produto
                                  )
                                  : undefined
                              }
                              isDisabled={ props.suggestionMode === "view" }
                            />
                          </Col>
                        </FormGroup>

                        <FormGroup className="mb-4" row>
                          <Label className="col-form-label col-lg-2">
                            Detalhes
                          </Label>
                          <Col lg="10">
                            <Editor
                              toolbarClassName="toolbarClassName"
                              wrapperClassName="wrapperClassName"
                              editorClassName="editorClassName"
                              editorState={ editorState }
                              onEditorStateChange={ e => setEditorState(e) }
                              placeholder="Digite os detalhes da sua sugestão..."
                              readOnly={ props.suggestionMode === "view" }
                            />
                          </Col>
                        </FormGroup>

                        <div className="inner-repeater mb-4">
                          <div className="inner form-group mb-0 row">
                            <Label className="col-form-label col-lg-2">
                              Anexar Arquivo (Opcional)
                            </Label>
                            <div className="inner col-lg-10 ms-md-auto">
                              <div className="mb-3 row align-items-center">
                                <Col md="12">
                                  { props.editingSuggestion &&
                                  props.editingSuggestion.arquivo && (
                                    <a href={ props.editingSuggestion.arquivo } target={ "_blank" }>
                                      <i className="bx bx-link" />
                                      <span>Clique para baixar o anexo</span>
                                    </a>
                                  ) }

                                  { props.suggestionMode !== "view" && (
                                    <div className="mt-4 mt-md-0">
                                      <Input type="file" className="form-control-file" onChange={ e => handleFile(e.target.files) } />
                                    </div>
                                  ) }
                                </Col>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

const mapStatetoProps = state => {
  const {
    sugestoesStatus,
    sugestoesProdutos,
    suggestionMode,
    activeSuggestion,
    sugestoesStatusLoading,
    sugestoesProdutosLoading,
    sugestaoLoading,
    editingSuggestion
  } = state.Profile
  return {
    sugestoesStatus,
    sugestoesProdutos,
    suggestionMode,
    activeSuggestion,
    sugestoesStatusLoading,
    sugestoesProdutosLoading,
    sugestaoLoading,
    editingSuggestion
  }
}

export default connect(mapStatetoProps, {
  buscarSugestoesStatus,
  buscarSugestoesProdutos,
  sugestao, doEditSuggestion, navegarBreadCrumb, buscarSugestao
})(CadastrarSugestao)
